import logo from './logo.svg';
import './App.css';
import DocumentList from './pages/docuemnt';
function App() {
  return (
    <div className="App">
      <DocumentList></DocumentList>
    </div>
  );
}

export default App;
